import { useSelector } from "react-redux";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

export const useIsAuthFinished = () => {
	return useSelector(state => isNonEmptyString(state?.shell?.cayuseHeader?.authenticationToken));
};

export default useIsAuthFinished;